import { IFetchList, IFetchDetail } from "./fetch-entity.interface";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';


export abstract class EntityService<TDetail, TList, TUpdate, TCreate> implements IFetchList, IFetchDetail {
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    protected httpClient: HttpClient,
    protected apiUrl: string) {
  }

  get(params: HttpParams) {
    return this.httpClient.get<TList[]>(this.apiUrl, { params: params, observe: 'response' });
  }

  getDetail(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.get<TDetail>(url);
  }

  create(user: TCreate) {
    return this.httpClient.post(this.apiUrl, JSON.stringify(user), { headers: this.headers });
  }

  update(user: TUpdate) {
    return this.httpClient.put(this.apiUrl, JSON.stringify(user), { headers: this.headers });
  }
}
